import React from "react";
import "../../styles/LearningStreams.css";

// Images
import school from "../../assets/Schhol.png";
import indian from "../../assets/indianProfes.png";
import global from "../../assets/globalProf.png";
import commerce from "../../assets/commrceDeg.png";
import skills from "../../assets/Skill.png";

const LearningStreams = () => {
  const streamsData = [
    {
      id: 1,
      theme: "blue",
      title: "Tuition Growth Programs",
      description:
        "CBSE & State Board coaching for Classes 1–12, with a focus on building strong academic foundations.",
      img: school,
      link: "https://tuition.madhiacademy.com"
    },
    {
      id: 2,
      theme: "purple",
      title: "Indian Professional Courses",
      description:
        "Chartered Accountant (CA), Cost & Management Accountant (CMA), and Company Secretary (CS) training with high pass rates.",
      img: indian,
      link: "https://pro.madhiacademy.com"
    },
    {
      id: 3,
      theme: "green",
      title: "Global Professional Courses",
      description:
        "International certifications including US CPA, US CMA, and EA, preparing students for global career opportunities.",
      img: global,
      link: "https://global.madhiacademy.com"
    },
    {
      id: 4,
      theme: "yellow",
      title: "Commerce Course Degrees",
      description:
        "Integrated B.Com programs combined with professional course preparation.",
      img: commerce,
      link: "https://degree.madhiacademy.com"
    },
    {
      id: 5,
      theme: "pink",
      title: "Industry Skills Training",
      description:
        "Practical job-oriented training in ERP, computer basics, and English communication.",
      img: skills,
      link: "https://skills.madhiacademy.com"
    }
  ];

  return (
    <section className="streams-section container">
      <h2 className="section-title">Our Specialized Learning Streams</h2>

      <div className="streams-grid">
        {streamsData.map((stream, index) => {
          const isLastCard = index === streamsData.length - 1;

          return (
            <div
              key={stream.id}
              className={`stream-card card-${stream.theme} ${
                isLastCard ? "centered-card" : ""
              }`}
            >
              {/* LEFT SIDE CONTENT */}
              <div className="card-content">
                <div className="card-title-wrap">
                  <h3 className="card-title">{stream.title}</h3>
                </div>

                <p className="card-description">{stream.description}</p>

                {/* READ MORE LINK */}
                <a
                  href={stream.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-more-btn"
                >
                  Read More
                </a>
              </div>

              {/* RIGHT SIDE IMAGE */}
              <div className="card-image-wrapper">
                <img
                  src={stream.img}
                  alt={stream.title}
                  className="stream-img"
                />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default LearningStreams;
